export const PARKING_SPACES = "Parking"
export const DORMITORY = "Dormitory"
export const ROOMS = "Room"
export const BEDROOM = "BedRoom"
